// Every one-time hint / tutorial / first-run banner flag we persist in localStorage.
// Clearing these makes all of them show again from scratch.
export const HINT_KEYS = [
  "sd_onboarding_v2",         // welcome tutorial dialog
  "sd_tours_tip",             // "Add your first tour" tip (Tours)
  "sd_possible_tip",          // Possible tours tip (Tours)
  "sd_fr_tip",                // Future Requests tip
  "sd_calendar_tip_dismissed",// Calendar "import your schedule" tip
  "sd_swipe_hint_seen",       // swipe-from-edge menu hint
  "sd_notif_nudge_until",     // notification nudge snooze
  "sd_install_nag_until",     // install-to-home-screen banner snooze
];

export function resetHints() {
  HINT_KEYS.forEach((k) => { try { localStorage.removeItem(k); } catch { /* ignore */ } });
}
